import { ProjectStatus } from "./workflow";

const STRIPE_PAYMENT_CONFIRMED_STATUSES = new Set(["paid", "pending", "no_payment_required"]);
const STRIPE_CHECKOUT_ACCEPTED_PAYMENT_STATUSES = new Set([
  "paid",
  "pending",
  "unpaid",
  "no_payment_required",
]);

const STATUS_META: Record<
  ProjectStatus,
  {
    label: string;
    className: string;
    description: string;
  }
> = {
  questionnaire_received: {
    label: "Neue Anfrage",
    className: "bg-blue-100 text-blue-700",
    description: "Fragebogen ist eingegangen und wartet auf Bearbeitung.",
  },
  draft_in_progress: {
    label: "Entwurf in Arbeit",
    className: "bg-slate-100 text-slate-700",
    description: "Der Entwurf wird aktuell intern erstellt.",
  },
  draft_ready: {
    label: "Entwurf bereit",
    className: "bg-amber-100 text-amber-800",
    description: "Entwurf ist hinterlegt, aber noch nicht an den Kunden gesendet.",
  },
  draft_sent: {
    label: "Beim Kunden",
    className: "bg-violet-100 text-violet-800",
    description: "Kunde prüft den Entwurf und kann kaufen oder Revision anfordern.",
  },
  revision_requested: {
    label: "Revision offen",
    className: "bg-orange-100 text-orange-800",
    description: "Änderungswünsche wurden eingereicht.",
  },
  ordered: {
    label: "Bestellt",
    className: "bg-emerald-100 text-emerald-800",
    description: "Das Paket wurde verbindlich bestellt.",
  },
  assets_pending: {
    label: "Wartet auf Daten",
    className: "bg-cyan-100 text-cyan-800",
    description: "Vertrag ist abgeschlossen, es fehlen noch Daten oder Uploads.",
  },
  finalizing: {
    label: "Finalisierung",
    className: "bg-fuchsia-100 text-fuchsia-800",
    description: "Website wird final umgesetzt und vorbereitet.",
  },
  live: {
    label: "Live",
    className: "bg-green-100 text-green-700",
    description: "Website ist online gestellt.",
  },
};

export function getProjectStatusMeta(status: ProjectStatus) {
  return STATUS_META[status];
}

export function formatCurrency(value: number) {
  return value.toLocaleString("de-DE", {
    style: "currency",
    currency: "EUR",
  });
}

export function formatDate(value: string | null | undefined) {
  if (!value) {
    return "-";
  }

  return new Date(value).toLocaleDateString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

export function formatDateTime(value: string | null | undefined) {
  if (!value) {
    return "-";
  }

  return new Date(value).toLocaleString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function isStripePaymentConfirmed(status: string | null | undefined) {
  return STRIPE_PAYMENT_CONFIRMED_STATUSES.has(status || "");
}

export function isStripeCheckoutAccepted(
  checkoutStatus: string | null | undefined,
  paymentStatus: string | null | undefined,
) {
  return checkoutStatus === "complete" && STRIPE_CHECKOUT_ACCEPTED_PAYMENT_STATUSES.has(paymentStatus || "");
}

export function getStripePaymentStatusLabel(status: string | null | undefined) {
  switch (status) {
    case "paid":
      return "Bezahlt";
    case "pending":
      return "In Verarbeitung";
    case "unpaid":
      return "In Verarbeitung";
    case "no_payment_required":
      return "Keine Zahlung erforderlich";
    default:
      return status || "Unbekannt";
  }
}
